export default __webpack_public_path__ + "static/media/logo_novo_final.ade985a1.png";